module.exports = __webpack_public_path__ + "img/bybit_1.2a651e92.png";